import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';

import { StripeService, Elements, Element as StripeElement, ElementsOptions } from "ngx-stripe";
import { BillingService } from '../billing.service';
import { GetService } from '../get.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.less']
})
export class StripeComponent {
  paid: boolean = false;
  user: any;
  elements: Elements;
  card: StripeElement;
  errorStripe: string = '';
  subscriptions = [];
  currentSubscription: any;
  isRequestInProgress: boolean = false;
    equineLang: any = localStorage.getItem('equineLang') || environment.defaultLanguage;
  // optional parameters
  elementsOptions: ElementsOptions = {
      locale: this.equineLang
  };
  translation = {};
  public stats = {};
 
  stripeTest: FormGroup;
  @Input() hideBilling: Function;
  constructor(
    private fb: FormBuilder,
    private stripeService: StripeService,
    private route:ActivatedRoute,
    private billingService: BillingService,
    private getService: GetService,
    public notificationsService: NotificationsService,
    public translateService: TranslateService) {
      this.getTranslation();
    }

  ngOnInit() {

      this.getStats()

      Promise.all([
          this.getService.getUser(),
          this.billingService.retrievePlans()
        ]).then(([user, response]) => {
          this.currentSubscription = response[0];
          this.user = user;
      })
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });
    this.stripeService.elements(this.elementsOptions)
      .subscribe(elements => {
        this.elements = elements;
        // Only mount the element the first time
        if (!this.card) {
          this.card = this.elements.create('card', {
            style: {
              base: {
                iconColor: '#002c09',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '12px',
                '::placeholder': {
                  color: '#CFD7E0'
                }
              }
            }
          });
          if (document.getElementById('card-element')) {
            this.card.mount('#card-element');
          }
        }
      });
  }

  getStats() {
    return this.getService.getBillingStats().then(res => {
          this.stats = res;
        }, err => {
        }
    );
  }

  resetForm() {
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });
    this.stripeService.elements(this.elementsOptions)
      .subscribe(elements => {
        this.elements = elements;
        // Only mount the element the first time
          this.card = this.elements.create('card', {
            style: {
              base: {
                iconColor: '#002c09',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '12px',
                '::placeholder': {
                  color: '#CFD7E0'
                }
              }
            }
          });
          if (document.getElementById('card-element')) {
            this.card.mount('#card-element');
          }
      });
  }

  buy() {
    // const name = this.stripeTest.get('name').value;
    this.isRequestInProgress = true;
    this.stripeService
      .createToken(this.card, {})
      .subscribe((token) => {
        if (token.error) {
          this.errorStripe = token.error.message;
          this.isRequestInProgress = false;
        }
        if (token && token.token) {
          return this.billingService.billingCustomer(token.token.id).then(response => {
            this.paid = true;
            this.notificationsService.success(
              this.translation['subscription'],
              this.translation['successSubscription']
            );
            $('body').removeClass('modal-open');
            this.billingService.setShow(false);
            this.isRequestInProgress = false;
          }).catch(error => {
            // Card confirmation error handling
            // Uncomment to close the modal in case of error on card confirmation
            // $('body').removeClass('modal-open');
            // this.billingService.setShow(false);
            this.resetForm();
            const serverError = error._body;
            this.notificationsService.error(
              this.translation['errorOccurred'],
              serverError.error
            );
            this.paid = false;
            this.isRequestInProgress = false;
          });
          // Use the token to create a charge or a customer
          // https://stripe.com/docs/charges
        }
      });
  }

  getTranslation() {
    this.translateService.get('CORE.subscription').subscribe((word: string) => {
      this.translation['subscription'] = word;
    });
    this.translateService.get('CORE.successSubscription').subscribe((word: string) => {
      this.translation['successSubscription'] = word;
    });
    this.translateService.get('OTHER.errorOccurred').subscribe((word: string) => {
      this.translation['errorOccurred'] = word;
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/stripe/stripe.component.ts